<div class="page-toolbar-container">
	<button class="page-nav-button crown-blue-background crown-light-blue-background-hover no-style" id="{{button.CssId}}" *ngFor="let button of PageButtons" (click)="button.ClickAction()" [disabled]="button.IsDisabled">
		<notification-badge [Count]="button?.NotificationBadge?.Count ?? 0" Top="-5px" Left="30px" />
		<span *ngIf="button.Icon" class="{{button.Icon.CssId}} button-icon">{{button.Icon.Name}}</span>
		<div>{{button.Title}}</div>
	</button>
</div>